import { ActionTypes } from "./actions.js";
import { getInitialState } from "./state.js";
const initialState = getInitialState();
const reducer = (state = initialState, action) => {
    if (action.type === ActionTypes.fetch) {
        const existing = state.fareOffersWithDetails[action.payload.baseOfferToken];
        const fareOffer = {
            baseOfferToken: action.payload.baseOfferToken,
            fetchStatus: "loading",
            error: undefined,
            brandedFareOffers: undefined,
            ...(existing?.comparisonTable && { comparisonTable: existing.comparisonTable }),
            ...(existing?.comparisonTableCompact && { comparisonTableCompact: existing.comparisonTableCompact })
        };
        return {
            ...state,
            fareOffersWithDetails: {
                ...state.fareOffersWithDetails,
                [action.payload.baseOfferToken]: {
                    ...fareOffer
                }
            }
        };
    }
    if (action.type === ActionTypes.fetchSuccess) {
        const baseOfferToken = action.payload.baseOfferToken;
        const brandedFaresFetched = action.payload.brandedFaresOffers;
        const comparisonTable = action.payload.comparisonTable;
        const comparisonTableCompact = action.payload.comparisonTableCompact;
        const existingFares = state.fareOffersWithDetails;
        const currentFare = {
            ...existingFares[baseOfferToken],
            brandedFareOffers: brandedFaresFetched,
            ...(comparisonTable !== undefined && { comparisonTable }),
            ...(comparisonTableCompact !== undefined && { comparisonTableCompact }),
            fetchStatus: "success"
        };
        return {
            ...state,
            fareOffersWithDetails: {
                ...existingFares,
                [baseOfferToken]: currentFare
            }
        };
    }
    if (action.type === ActionTypes.fetchError) {
        const existingFares = state.fareOffersWithDetails;
        return {
            ...state,
            fareOffersWithDetails: {
                ...existingFares,
                [action.payload.baseOfferToken]: {
                    fetchStatus: "failed",
                    error: action.payload.error
                }
            }
        };
    }
    if (action.type === ActionTypes.selectFare) {
        return {
            ...state,
            selectedFareToken: action.payload.fareToken
        };
    }
    if (action.type === ActionTypes.reset) {
        return getInitialState();
    }
    return state;
};
export { reducer, getInitialState };
